<template>
  <div>
    <i-publish-status-indicator :status="status" @click.prevent="showModal = true" />
    <ModalPublishStatus :document="this.item" v-model:show="showModal"/>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import DocumentPublishStatusIndicator, { PublishStatus } from '@/components/browser/documents/DocumentPublishStatusIndicator.vue';
import ModalPublishStatus from './ModalPublishStatus.vue';

export default defineComponent({
  inheritAttrs: false,
  components: {
    ModalPublishStatus,
    [DocumentPublishStatusIndicator.name]: DocumentPublishStatusIndicator,
  },
  props: {
    item: Object,
  },
  computed: {
    status() {
      return {
        0: PublishStatus.NOT_PUBLISHED,
        1: PublishStatus.PUBLISHED,
        2: PublishStatus.SOME_PUBLISHED,
      }[this.item.is_published];
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
});
</script>
